import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    Beacon?: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class HelpscoutBeaconService {
  private readonly BEACON_ID = environment.helpscoutBeaconId;
  private readonly SCRIPT_ID = 'helpscout-beacon-script';
  private scriptLoaded = false;

  isInitialized(): boolean {
    return this.scriptLoaded && !!window.Beacon;
  }

  destroy(): void {
    if (window.Beacon && typeof window.Beacon === 'function') {
      try {
        console.log('HelpscoutBeacon: Destroying beacon');
        window.Beacon('destroy');
      } catch (e) {
        console.error('Error destroying Helpscout Beacon:', e);
      }
    }

    const script = document.getElementById(this.SCRIPT_ID);
    console.log('HelpscoutBeacon: Removing script');
    script?.parentNode?.removeChild(script);

    delete (window as any).Beacon;
    this.scriptLoaded = false;
  }

  async init(): Promise<void> {
    if (this.isInitialized()) {
      console.log('HelpscoutBeacon: Already initialized');
      return;
    }

    if (!document.getElementById(this.SCRIPT_ID)) {
      console.log('HelpscoutBeacon: Loading script');
      this.loadScript();
    }

    this.initializeBeacon();
  }

  private loadScript(): void {
    const script = document.createElement('script');
    script.id = this.SCRIPT_ID;
    script.type = 'text/javascript';
    script.textContent = this.getBeaconLoaderScript();
    document.body.appendChild(script);
    this.scriptLoaded = true;
    console.log('HelpscoutBeacon: Script loaded');
  }

  private getBeaconLoaderScript(): string {
    return `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});`;
  }

  private initializeBeacon(): void {
    try {
      if (window.Beacon && typeof window.Beacon === 'function') {
        console.log('HelpscoutBeacon: Initializing');
        window.Beacon('init', this.BEACON_ID);
        this.scriptLoaded = true;
        console.log('HelpscoutBeacon: Initialization complete');
      } else {
        console.warn('HelpscoutBeacon: Beacon function not available');
      }
    } catch (error) {
      console.error('Error initializing Helpscout Beacon:', error);
    }
  }
}
